// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"670e15c7","455":"eb413635","977":"b761c659"}[chunkId] + ".chunk.js";
};